import React from "react";
import styled from "styled-components";
import { Container } from "~/Auth";

export const NotAuthorized = () => {
  return (
    <Container data-testid="not-authorized">
      <ConstructionBlockedSign />
      <WarningText>You do not have access to this application.</WarningText>
      <CTAText>Please contact our support for more information.</CTAText>
    </Container>
  );
};

export const ConstructionBlockedSign = () => (
  <svg
    fill={"none"}
    viewBox={"0 0 456 358"}
    xmlns={"http://www.w3.org/2000/svg"}
  >
    <g clipPath={"url(#b)"}>
      <g opacity={".1"}>
        <path
          d={
            "m2.3009 263.2l164.4 92.3c4.1 2.3 9.1 2.2 13.1-0.2l249.5-149.1c2.1-1.3 2.8-4 1.6-6.1-0.4-0.7-1-1.2-1.6-1.6l-164.4-92.3c-4.1-2.3-9.1-2.2-13.1 0.2l-249.6 149c-2.1 1.3-2.8 4-1.5 6.1 0.3 0.7 0.9 1.3 1.6 1.7z"
          }
          fill={"#535252"}
          opacity={".5"}
        />
      </g>
      <path
        d={"m129.6 130.7l-51.8 113.1-13.8 8 51.8-113.2 13.8-7.9z"}
        fill={"#818181"}
      />
      <path
        d={"m100.5 129.7l-52.4 113.1 15.6 9 52.1-113.2-15.3-8.9z"}
        fill={"#aaa"}
      />
      <path
        d={"m304.4 29.8l-51.8 113.1-13.8 8 51.8-113.2 13.8-7.9z"}
        fill={"#A1A537"}
      />
      <path
        d={"m275.4 28.8l-52.5 113.1 15.6 9 52.1-113.2-15.2-8.9z"}
        fill={"#aaa"}
      />
      <path
        d={"m129.6 130.7l-13.8 7.9 64.2 180.3 13.8-8-64.2-180.2z"}
        fill={"#818181"}
      />
      <path
        d={"m129.3 130.7l-15.3-8.8-13.5 7.8 15.3 8.9 13.5-7.9z"}
        fill={"#E6E6E5"}
      />
      <path
        d={"m115.8 138.6l-15.3-8.9 64.3 180.5 15.2 8.7-64.2-180.3z"}
        fill={"#aaa"}
      />
      <path
        d={"m304.4 29.8l-13.8 7.9 64.2 180.3 13.8-8-64.2-180.2z"}
        fill={"#818181"}
      />
      <path
        d={"m304.1 29.8l-15.3-8.8-13.4 7.8 15.2 8.9 13.5-7.9z"}
        fill={"#E6E6E5"}
      />
      <path
        d={"m290.6 37.7l-15.2-8.9 64.2 180.5 15.2 8.7-64.2-180.3z"}
        fill={"#aaa"}
      />
      <path
        d={
          "m325.2 29.3l-223.2 128.7 27.3 76.7 12.5 7.2 210.4-135.8-14.4-69.6-12.6-7.2z"
        }
        fill={"#4E4E4E"}
      />
      <path
        d={"m114.5 165.2l-12.5-7.2 27.3 76.7 12.5 7.2-27.3-76.7z"}
        fill={"#818181"}
      />
      <path
        d={"m337.8 36.5l-223.3 128.7 27.3 76.7 223-128.6-27-76.8z"}
        fill={"#E6E6E5"}
      />
      <mask
        id={"a"}
        x={"52"}
        y={"0"}
        width={"404"}
        height={"275"}
        style={{ maskType: "alpha" }}
        maskUnits={"userSpaceOnUse"}
      >
        <path
          d={"m451.2 90.4l-211.6-79.6"}
          stroke={"#F47625"}
          strokeMiterlimit={"10"}
          strokeWidth={"23.06"}
        />
        <path
          d={"m405.4 133.7l-211.6-79.6"}
          stroke={"#F47625"}
          strokeMiterlimit={"10"}
          strokeWidth={"23.06"}
        />
        <path
          d={"m359.5 177l-211.6-79.6"}
          stroke={"#F47625"}
          strokeMiterlimit={"10"}
          strokeWidth={"23.06"}
        />
        <path
          d={"m313.6 220.3l-211.5-79.6"}
          stroke={"#F47625"}
          strokeMiterlimit={"10"}
          strokeWidth={"23.06"}
        />
        <path
          d={"m267.8 263.6l-211.6-79.6"}
          stroke={"#F47625"}
          strokeMiterlimit={"10"}
          strokeWidth={"23.06"}
        />
      </mask>
      <g mask={"url(#a)"}>
        <path
          d={"m337.8 36.5l-223.3 128.7 27.3 76.7 223-128.6-27-76.8z"}
          fill={"#F47625"}
        />
      </g>
    </g>
    <defs>
      <clipPath id={"b"}>
        <rect width={"455.3"} height={"357.1"} fill={"#fff"} />
      </clipPath>
    </defs>
  </svg>
);

export const WarningText = styled.div`
  font-style: normal;
  font-weight: bold;
  font-size: 27px;
  line-height: 40px;
`;

export const CTAText = styled.div`
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;
`;
